<template>
  <div class="container">
    <div class="editor">
      <JsonEditorVue mode="text" v-model="value" />
    </div>

    <div class="viewer">
    	<Multiselect
        v-model="currentSize"
        :options="screenSizes"
        label="title"
        placeholder="Размер"
        @update:modelValue="updateCurrentSize"
      />
    	<button class="update__button" @click="updateComponents()">Обновить</button>
      <div class="main-middle__container">
        <div :class="['middle', mainBlockStyles, { readonly }]">
          <mainBlock 
            :jsoneditor="true" 
            :readonly="true" 
            :previewLandingData="list"
          />
        </div>
      </div>
      <hr/>
    </div>
  </div>
</template>

<script>
import JsonEditorVue from 'json-editor-vue'
import componentsList from '@/config/components-list-v1.js'
import mainBlock from "@/components/blocks/index.vue";
import { safeClone } from '@/utils/clone.js';
import Multiselect from "@/components/UI/Select/Multiselect.vue";
import { screenSizes } from '@/config/screen-sizes.js'
import { mapGetters } from "vuex"

export default {
  name: 'JsonEditorWithViewer',
  components: {
    JsonEditorVue,
    mainBlock,
    Multiselect
  },
  data() {
    return {
      value: {},
      list: [],
      updateTimeout: null,
      currentSize: null,
      screenSizes
    }
  },
  mounted() {
    this.value = safeClone(componentsList);

    this.list = componentsList.map(item => safeClone(item.list[0]));
  },
  watch: {
    value: {
      handler() {
        if (this.updateTimeout) clearTimeout(this.updateTimeout);

        this.updateTimeout = setTimeout(() => {
          this.updateComponents();
        }, 5000);
      },
      deep: true 
    }
  },
  computed: {
    ...mapGetters("landing", ["landingSettings"]),
    mainBlockStyles () {
      if(this.readonly) return ''
      let ind = screenSizes?.findIndex(item => item.title === this.landingSettings?.size?.width + 'px');
      if (ind === 0) return 'middle-large'
      if (ind === 1) return 'middle-normal'
      if (ind === 2) return 'middle-small'
      return ''
    }
  },
  methods: {
  	updateCurrentSize (size) {
      const width = parseInt(size.title);
      const height = window.innerHeight;

      this.$store.dispatch("landing/UPDATE_LANDING_SETTINGS", {
        size: { width, height }
      });
    },
  	updateComponents() { 
  		this.list = [] 
  		
  		if(typeof this.value !== 'object') 
  			this.value = JSON.parse(this.value) 

				this.value.forEach(item=>{ 
					this.list.push(safeClone(item.list[0])) 
				}) 
  	},
    updateList() {
      if (typeof this.value === 'string') {
        try {
          this.value = JSON.parse(this.value);
        } catch (e) {
          console.warn('Некорректный JSON, пропускаем обновление list');
          return;
        }
      }

      if (Array.isArray(this.value)) {
        this.list = this.value.map(item => safeClone(item.list[0]));
      } else {
        this.list = [];
      }
    }
  }
}
</script>


<style>
.jse-main {
	min-height: 100vh !important
}
</style>
<style scoped>
.container {
  display: flex;
  flex-direction: row;
  margin: 0;
  min-width: 100vw;
  padding: 0;
}



.viewer {
	position: fixed;
  right: 0;
	overflow: scroll;
}


.viewer, .editor {
	width: 50%;
	height: 100%;
	min-height: 100vh;
}
pre {
  background: #f4f4f4;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 14px;
}
.update__button {
	margin: 2rem;
	position: fixed;
	bottom: 0;
	right: 0;
	border-radius: 50%;
	height: 10rem;
	width: 10rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	font-size: 1.5rem;
  z-index: 2;
  border: 0.2rem solid black;
}

.middle {
  width: calc(100% - 44%);
  margin: auto;
  padding: 2rem;
  min-height: 100vh;
  overflow-y: scroll;
  height: 100%;
  position: relative;
  padding-bottom: 5rem;
  padding-top: 5rem;
}

.middle.readonly {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.middle-large {
  transform: scale(.7);
  transform-origin: top left;
  margin: 0;
  padding: 0;
  width: 143%;
}

.middle-normal {
  width: 100%;
  padding: 0;
}
.middle-small {
  width: 100%;
  padding: 0;
}

@media (max-width: 768px) {
  .middle {
    width: 100%;
    margin: 0;
    padding: 0;
    padding-top: 3.1rem;
  }
}
.main-middle__container {
  
}
</style>
